export default __webpack_public_path__ + "static/media/Ceprocon-500-ban.2d21f2d5.jpg";